import { createFileRoute } from "@tanstack/react-router";
import { Globe } from "@phosphor-icons/react";

import { PageHeader } from "@/components/layout/heading";
import { Button } from "@/components/ui/button";
import { EmptyIcon } from "@/components/icons/empty";

import { BrandResearchCard } from "@/components/card/brand-intelligence/brand";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/dashboard/_layout/research")({
  component: RouteComponent,
});

function RouteComponent() {
  const { profile } = useSession();

  const hasResearch = !!profile.company.brand_research_started_at;

  return (
    <section id="research">
      <PageHeader title="Research Labs" description="Deep dive into your brand research and reports">
        <Button className="w-40" disabled>
          <Globe className="size-5" />
          <span>New Report</span>
        </Button>
      </PageHeader>
      <div className="mt-8">
        {hasResearch ? (
          <div className="flex flex-col gap-6">
            <BrandResearchCard />
          </div>
        ) : (
          <div className="h-96 flex flex-col items-center justify-center p-10 text-center border border-dashed rounded-2xl">
            <EmptyIcon className="size-28 -mt-8" />
            <p className="text-base font-medium mt-2 mb-1">No research found</p>
            <p className="text-sm text-muted-foreground">Start a research and get a report on your brand</p>
          </div>
        )}
      </div>
    </section>
  );
}
